module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAT9JREFUOE+9lLFKxEAQhvffLKkVxUZLwUoiu5ve2s4XsPIBtLKwEJ9AEVtLa59AtJUki6CVD2AhijaCmMuOjBg4j+SydxFTbfHPl392/lkURUFi+u/eGLM6XI4+QABvWuvZ/wMaYxDSfd1Vp8M/B3rvd0McSimPWNfpMAT2awBdQ2GHURQdcFFVVYd8JqKZth91OiSiaynlGgO897d8bgF6IcQHgM9esQHgiejcGLPV6nrCYO8rpS4Hg8GFEGLhB/qklNpMkuTme1ChQCJ6sNauOOeeiWhuZDgvWuv5iYAATr337wD2mtolojNr7XawwziOl8uyPCGiDV4A59zryMAejTGLwUCG5Hl+BWC9CVhHaCpgnddhh72ATXcYDGQhb02apsdZlu2MW0/WcMt3AJbGCXkbumB1fdD7x+LQvH4BlIHVTAOBMrMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/merchant_gry.png
// module id = x7AN
// module chunks = 2